<template>
    <div class="bot-spinner">
        <v-overlay :absolute="true" :value="value.visible">
            <v-progress-circular
                indeterminate
                :color="value.color"
            ></v-progress-circular>
        </v-overlay>
        <slot />
    </div>
</template>

<script>
export default {
    name: "BotSpinner",

    props: ["value"],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.bot-spinner {
    position: relative;
}
</style>



// WEBPACK FOOTER //
// bot.spinner.vue